<template lang="pug">
  .Paragraph.Paragraph-margin.ParagraphDrawers
    .ParagraphDrawers_wrapper
      MediaCarousel(
        :items="item.drawers"
        itemTitleProperty="attributes.title")
        router-link(slot-scope="{ item }" :to="$tools.getURL(item.rel.drawer.attributes.path)")
          //- img(:src="item.rel.drawer.rel.media.rel.thumbnail.attributes.url" :alt="item.attributes.subtitle" v-if="item.rel.drawer.rel.media")
          AdaptativeImg(v-if="item.rel.drawer.rel.media.rel.field_image.links" :derivatives="item.rel.drawer.rel.media.rel.field_image.links" :type="'block'" :fit="false" :name="item.attributes.subtitle")

</template>

<script>

import MediaCarousel from '@/components/MediaCarousel'
import AdaptativeImg from '@/components/common/AdaptativeImg'

export default {
  components: {
    MediaCarousel,
    AdaptativeImg
  },
  props: ['item'],
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>

.ParagraphDrawers
  &_wrapper
    width 100%

</style>
